module.exports = "<p>\n  new-trip-summary works!\n</p>\n"